import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAppConfigContext } from '@/context/AppConfig';
import { useReportRedirect } from '@/reports/useReportRedirect/useReportRedirect';
import { vehicleSearch } from '@/reports/vehicle/vehicleSearch';

export const useVehicleSearchByTrim = (
  year: string,
  make: string,
  model: string,
  trim: string
) => {
  const { logError } = useAppConfigContext();
  const { redirectToReportUrl } = useReportRedirect();
  const queryClient = useQueryClient();
  const result = useQuery({
    queryKey: ['vehicleSearch'],
    queryFn: () => {
      return vehicleSearch({ year, make, model, trim });
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(['report']);
      redirectToReportUrl('vehicle', data.report.permalink);
    },

    enabled: Boolean(year) && Boolean(make) && Boolean(model) && Boolean(trim),
    onError: (error) => {
      logError('Error fetching vehicle', error as Error);
    },
  });

  return { ...result };
};
